<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Livro Ocorrências
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Livro Ocorrências
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Unidade',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search

      .row.clearfix
        .col-lg-12.col-md-12.col-sm-12
          .card
            .header
              h2
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'tenant.book.occurrence.index'}") Listagem
                    li
                      router-link(:to="{name: 'tenant.book.occurrence.create'}") Cadastro
            .body.m-b-10
              .form-group
                v-input(:status="$v.occurrence.content.$error ? 'error' : null")
                  textarea.form-control.no-resize(
                    rows='4',
                    placeholder='Digite sua ocorrência'
                    v-model="occurrence.content"
                    :disabled="seeUploadImage"
                    :maxlength="max",
                    style="text-align: justify;"
                  )
                span(style="color: #898989;") Caracteres restantes
                  span.badge.badge-warning.mt-0(style="margin-left: 5px;") {{ max - (occurrence.content !== null ? occurrence.content.length : 0 ) }}

              .post-toolbar-b
                .row
                  f-dweller-image-book(:book-occurrence="book_occurrence")
                button.btn.btn-primary.btn-round(
                  :disabled="seeUploadImage"
                  @click.prevent="doSave()",
                ) Salvar
                span.cursor-pointer#uploadBookImage(style="with")
                  button.btn.btn-warning.btn-icon.btn-icon-mini.btn-round(
                    v-if="seeUploadImage"
                  )
                    i.zmdi.zmdi-camera
                button.btn.btn-danger.btn-icon.btn-icon-mini.btn-round(
                  :disabled="seeUploadImage"
                  @click.prevent="doClear()"
                )
                  i.zmdi.zmdi-delete
            .body.m-b-10(v-if="occurrence.image.length >= 1")
              template
                .form-group
                  span
                    img.img-thumbnail.m-t-10.cursor-pointer#uploadBookImage(
                        :src='occurrence.image[0].url', alt='Occurrence_img',
                        width='300'
                      )
            .body.m-b-10(v-if="occurrence.img")
              .form-group
                span
                  img.img-thumbnail.m-t-10.cursor-pointer#uploadBookImage(
                      :src='occurrence.img', alt='Occurrence_img',
                      width='300'
                    )

</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/book-occurrence/form/form.vue